const HOST = process.env.REACT_APP_API_URL || "xxxx please set api url in web/.env file xxxx ";
const RESELLER_HOST = process.env.REACT_APP_RESELLER_URL || "xxxx please set reseller console  url in web/.env file xxxx ";
const API_HOST = `${HOST}api/`;
export { API_HOST, HOST, RESELLER_HOST, };
